<template>
  <v-app>
    <v-main style="width: 100%">
      <router-view v-if="isMobile" />
      <router-view v-else />
    </v-main>
  </v-app>
</template>

<script>
export default {
  components: {},
  name: "App",
  computed: {
    isMobile() {
      return this.$store.state.isMobile;
    },
  },
  mounted() {
    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }

    // DOM 렌더링 후 약간의 지연을 추가
    this.$nextTick(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }, 100); // 100ms 지연
    });
  },
};
</script>
